export default "__VITE_ASSET__oLctSWKj__"